import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledSearch = styled.div<{ isTechContemporary?: boolean }>`
    position: relative;

    & svg {
        position: absolute;
        top: ${({ isTechContemporary }) => (isTechContemporary ? '15px' : 'calc(50% - 10px)')};

        &:nth-of-type(1) {
            left: 15px;
        }

        &:nth-of-type(2) {
            right: 15px;
            cursor: pointer;
        }
    }

    & input {
        padding-left: 40px;
        padding-right: 40px;
        width: 100%;
        font-size: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    ${media.sm`
      flex: 5;
    `}
    ${media.md`
      & svg:nth-of-type(1) {
      top: ${({ isTechContemporary }: { isTechContemporary: boolean }) =>
          isTechContemporary ? '13px' : 'calc(50% - 10px)'}; 
      }
    `}
  & input {
        ${({ isTechContemporary }) => isTechContemporary && 'background: transparent; border: none'};

        :focus {
            ${({ isTechContemporary }) =>
                isTechContemporary &&
                'background: transparent; border: none; border-bottom: 1px solid rgba(255, 255, 255, 0.15); border-radius: 0'};
        }
    }
`;